import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select, { components } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { Checkbox } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';
import ContactsPeopleSelectionModal from 'components/selection_modals/contacts_people';
import ContactsPropertiesSelectionModal from 'components/selection_modals/contacts_properties';
import CallListSelectionModal from 'components/selection_modals/call_list';
import ProjectsSelectionModal from 'components/selection_modals/projects';

import '../../styles/contacts.scss';

const customOptions = (innerProps) => {
  return (
    <components.Option className="select-dropdown" {...innerProps}>
      <div value={innerProps.data.value}>
        <img
          className="dropdown-bubble left-buffer-sm right-buffer-md"
          src={innerProps.data.dataPhoto}
          value={innerProps.data.value}
        />
        <span className="left-buffer-md" value={innerProps.data.value}> {innerProps.data.label} </span>
      </div>
    </components.Option>
  );
};

export default class NewTaskForm extends React.Component {
  static propTypes = {
    callListsAccess: PropTypes.bool.isRequired,
    canFollowUp: PropTypes.bool,
    databaseMembers: PropTypes.array.isRequired,
    defaultTaskAssignee: PropTypes.object,
    followUp: PropTypes.bool,
    isCompleted: PropTypes.bool,
    person: PropTypes.object,
    task: PropTypes.object.isRequired,
    onAddAssociation: PropTypes.func.isRequired,
    onRemoveAssociation: PropTypes.func.isRequired,
    onRemoveTaskListAssociation: PropTypes.func.isRequired,
    onTaskChange: PropTypes.func.isRequired,
    onToggleFollowUp: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      showPeopleModal: false,
      showPropertiesModal: false,
      showProjectsModal: false,
      showCallListModal: false,
    };
  }

  handleTaskBodyChange = e => this.props.onTaskChange(e.target.value, "body");
  handleTaskTitleChange = e => this.props.onTaskChange(e.target.value, "title");
  handleTaskTypeSelect = e => this.props.onTaskChange(parseInt(e.target.value), "taskType");
  handleTaskDateChange = date => this.props.onTaskChange(date, "dueDate");
  handleMemberSelect = e => this.props.onTaskChange(parseInt(e.value), "assigneeId");

  associateCallListsToTask = (callLists) => {
    const { task } = this.props;

    callLists.forEach((cl) => {
      cl.task_list_id = cl.id;
      cl.task_id = task.id;
      delete cl.id;
      delete cl.tasks;
    });

    this.props.onTaskChange(callLists, "taskListItems");
    this.closeModals();
  };

  openPeopleModal = () => {
    this.setState({
      showPeopleModal: true
    });
  };

  openPropertiesModal = () => {
    this.setState({
      showPropertiesModal: true
    });
  };

  openProjectsModal = () => {
    this.setState({
      showProjectsModal: true
    });
  };

  openCallListModal = () => {
    this.setState({
      showCallListModal: true
    });
  };

  closeModals = () => {
    this.setState({
      showCallListModal: false,
      showPeopleModal: false,
      showProjectsModal: false,
      showPropertiesModal: false
    });
  };

  associateToTask = (associations, model) => {
    this.props.onAddAssociation(associations, model);
    this.closeModals();
  };

  assigneeOptions = () => {
    const options = this.props.databaseMembers || [];
    return options.map((u) => {
      return {
        value: u.id,
        label: u.name,
        dataPhoto: u.dataPhoto
      };
    });
  };

  render() {
    const {
      isCompleted,
      canFollowUp,
      followUp,
      onToggleFollowUp,
      task
    } = this.props;

    const {
      showPeopleModal,
      showPropertiesModal,
      showCallListModal,
      showProjectsModal
    } = this.state;

    if (!task.associatedModels) task.associatedModels = [];

    const associatedPeople = task.associatedModels.filter(model => model.associatedModelType === "Contacts::Person");
    const associatedProperties = task.associatedModels.filter((model) => {
      return model.associatedModelType === "Research::Property";
    });

    return (
      <div className="contact-preview-task-form">
        <div className="activity-block bottom-buffer-md">
          {this.renderTaskTypes()}
          {this.renderDatePicker()}
        </div>
        {this.renderTextAreas()}
        {!isCompleted && this.renderAssigneeSelectDropdown()}
        {this.renderAssociationSelectors()}
        {this.renderAssociatedContacts()}
        {canFollowUp &&
          <div className="pull-left">
            <Checkbox
              checked={followUp}
              inline
              name="follow-up-check"
              onChange={onToggleFollowUp}
            >
            Create a follow-up Task
            </Checkbox>
          </div>
        }
        <ContactsPeopleSelectionModal
          modalTitle="Add people to the task"
          selectedItems={associatedPeople}
          show={showPeopleModal}
          onCancel={this.closeModals}
          onOk={e => this.associateToTask(e, "Contacts::Person")}
        />
        <ContactsPropertiesSelectionModal
          modalTitle="Add properties to the task"
          selectedItems={associatedProperties}
          show={showPropertiesModal}
          onCancel={this.closeModals}
          onOk={e => this.associateToTask(e, "Research::Property")}
        />
        <CallListSelectionModal
          modalTitle="Add call lists to the task"
          selectedItems={task.taskListItems || []}
          show={showCallListModal}
          onCancel={this.closeModals}
          onOk={this.associateCallListsToTask}
        />
        <ProjectsSelectionModal
          limit={1}
          modalTitle="Add projects to the task"
          selectedItems={[]}
          show={showProjectsModal}
          onCancel={this.closeModals}
          onOk={e => this.associateToTask(e, "Project")}
        />
      </div>
    );
  }

  renderAssociationSelectors() {
    const { callListsAccess, task } = this.props;
    const associatedProjects = task.associatedModels.filter(model => model.associatedModelType === "Project");

    return (
      <div className="association-block top-buffer-sm">
        <div className="pull-left">
          <a className="association-link" onClick={this.openPeopleModal}>
            + Contact
          </a>
          <a className="association-link" onClick={this.openPropertiesModal}>
            + Property
          </a>

          {associatedProjects.length === 0 &&
            <a className="association-link" onClick={this.openProjectsModal}>
              + Project
            </a>
          }
          {(task.taskType === 1 && callListsAccess) &&
            <a className="association-link" onClick={this.openCallListModal}>
              + List
            </a>
          }
        </div>
      </div>
    );
  }

  renderAssociatedContacts() {
    const {
      task,
      person,
      onRemoveTaskListAssociation
    } = this.props;

    const contacts = [];

    if (!task.associatedModels) task.associatedModels = [];

    task.associatedModels.forEach((association, i) => {
      if (
        person && association.associatedModelId == person.id && association.associatedModelType === 'Contacts::Person'
      ) {
        contacts.push(
          <span className="task-association-box top-buffer-xs right-buffer-sm" key={i}>
            {association.name}
          </span>
        );
      } else {
        contacts.push(
          this.renderAssociatedTag(association.associatedModelId, association.name, association.associatedModelType)
        );
      }
    });

    if (task.taskListItems) {
      contacts.push(task.taskListItems.map((association) => {
        return (
          <span className="task-association-box top-buffer-xs right-buffer-sm" key={association.id}>
            List: {association.name}
            <FontAwesomeIcon
              className="left-buffer-sm clickable"
              icon={faTimes}
              size="sm"
              onClick={() => onRemoveTaskListAssociation(association.id)}
            />
          </span>
        );
      }));
    }

    return (
      <div className="bottom-buffer-sm">
        {contacts}
      </div>
    );
  }

  renderAssociatedTag(id, name, model) {
    const { onRemoveAssociation } = this.props;
    return (
      <span className="task-association-box top-buffer-xs right-buffer-sm" key={id + model}>
        {name}
        <FontAwesomeIcon
          className="left-buffer-sm clickable"
          icon={faTimes}
          size="sm"
          onClick={() => onRemoveAssociation(id, model)}
        />
      </span>
    );
  }

  renderDatePicker() {
    const {
      isCompleted,
      task
    } = this.props;

    const today = moment.isMoment(task.dueDate) ? task.dueDate.isSame(moment(), 'day') : null;

    return (
      <div className="filter-datepicker">
        <ManagedInput
          className="form-control"
          fixedHeight
          maxTime={today && !isCompleted ? moment().endOf('day') : null}
          minDate={isCompleted ? null : moment()}
          minTime={today && !isCompleted ? moment() : null}
          placeholderText="Start Date"
          type="datetime"
          value={task.dueDate}
          onValueChange={this.handleTaskDateChange}
        />
      </div>
    );
  }

  renderTaskTypes() {
    const { isCompleted } = this.props;
    return (
      <div>
        <select
          className="form-control task-type d-inline-block w-auto"
          defaultValue={1}
          id="taskType"
          onChange={this.handleTaskTypeSelect}
        >
          <option key="callType" value={1}>{isCompleted ? "Log Call" : "Call"}</option>
          <option key="emailType" value={2}>{isCompleted ? "Log Email" : "Email"}</option>
          <option key="meetingType" value={3}>{isCompleted ? "Log Meeting" : "Todo"}</option>
          <option key="criticalDateType" value={9}>"Critical Date"</option>
        </select>
      </div>
    );
  }

  renderTextAreas() {
    const { task } = this.props;
    return (
      <div>
        <textarea
          className="textarea-summary full-width"
          placeholder= "Summary (required) ...."
          value={task.title}
          onChange={this.handleTaskTitleChange}
        />
        <textarea
          className="textarea-minimal no-border full-width"
          placeholder= "Enter Details..."
          value={task.body}
          onChange={this.handleTaskBodyChange}
        />
      </div>
    );
  }

  renderAssigneeSelectDropdown() {
    const { defaultTaskAssignee } = this.props;
    const defaultAssigneeOptions = [{
      value: defaultTaskAssignee.id,
      label: defaultTaskAssignee.name
    }];
    return (
      <Select
        components={{
          Option: customOptions
        }}
        defaultValue={defaultAssigneeOptions}
        options={this.assigneeOptions()}
        placeholder={'Assign Task to User'}
        onChange={this.handleMemberSelect}
      />
    );
  }
}
